export const PERMISSION_ACTIONS = ["view", "edit", "delete"];

export const RETAINED_ROLE_NAMES = [
  "Auditor",
  "Driver Manager",
  "Gateway",
  "Learning Centre Manager",
  "L.E.E.P.",
  "Manager",
  "Recruiter",
  "Road Tester",
  "Safety Supervisor",
  "Admin",
  "Super Admin",
];

const page = (name, label, resources) => ({ name, label, resources });

export const PERMISSION_CATALOG = [
  page("AdminDashboard", "Admin Dashboard", [
    "User",
    "Driver License",
    "Health Card",
    "Passport",
    "Fast Card",
    "PR Card",
    "US Visa",
    "Work Permit",
    "Work History",
    "Vacation",
    "Emergency Contact",
    "Direct Deposit",
    "Fuel Card",
  ]),
  page("AdminUser", "User Management", ["User"]),
  page("GroupPage", "Group Management", ["Group"]),
  page("Recruitment", "Recruitment", ["Job Descriptions", "Positions"]),
  page("Reports", "Reports", [
    "Reports Home",
    "Contact List",
    "L.E.E.P. Report",
    "Time and Attendance",
    "Expirations",
    "Associate Turnover",
    "Hiring Cycle",
    "Hiring Cycle Data",
    "Position History",
    "Termination",
    "Document Status",
    "Incident / Accident Registry",
  ]),
  page("AccountSetting", "Admin Settings", [
    "Profile",
    "Tags",
    "Dropdown Manager",
    "Interview Question",
    "Training Quiz",
    "Custom Task Create Helper",
    "Reference Check",
    "Notifications / Alerts",
    "Scheduler Management",
    "Announcement Center",
    "API Tokens",
    "Policy Create",
  ]),
  page("PermissionManagerPage", "Security Centre", ["Permissions", "Roles"]),
  page("Communications", "Communications", [
    "Alerts",
    "Email",
    "Communications",
  ]),
  page("UserProfile", "User Profile", [
    "Personal Information",
    "Status History",
    "Application History",
    "Tags",
  ]),
  page("Training", "Training", ["Online Training"]),
  page("Interview", "Interview", ["Interview"]),
  page("Task", "Tasks", [
    "Task Assignment",
    "SIN",
    "Work History",
    "Health Card",
    "Fast Card",
    "Fuel Card",
    "Work Permit",
    "Driver Abstract",
    "Road Test",
    "Roadside Inspection",
    "Driver License",
    "Vacation",
    "Incident / Accident",
    "Violation",
    "Annual Driver Certification",
    "Driver Disclosure",
    "Dangerous Work",
    "Zero Tolerance",
    "Truck Assignment",
    "Health and Safety",
    "Padlock Probe",
    "Background Check FCRA",
    "Qualifications",
    "Driver Employee Agreement",
    "Gate Pass",
    "Resume",
    "Reference Check",
    "L.E.E.P.",
    "Consent",
    "Signed Release",
    "Clearinghouse",
  ]),
].map((entry) => ({
  ...entry,
  resources: entry.resources.map((resource) => ({
    name: resource,
    label: resource,
  })),
}));

const route = (pattern, pageName, resource) => ({
  pattern,
  page: pageName,
  resource,
});

export const PERMISSION_ROUTES = [
  route(/^\/communications\/compose(?:\/|$)/, "Communications", "Email"),
  route(/^\/communications(?:\/|$)/, "Communications", "Communications"),
  route(/^\/admin-users(?:\/|$)/, "AdminUser", "User"),
  route(/^\/(?:edit-user\/[^/]+|form)(?:\/|$)/, "AdminUser", "User"),
  route(/^\/admin-groups(?:\/|$)/, "GroupPage", "Group"),
  route(/^\/job-descriptions(?:\/|$)/, "Recruitment", "Job Descriptions"),
  route(/^\/positions(?:\/|$)/, "Recruitment", "Positions"),
  route(/^\/permissions(?:\/|$)/, "PermissionManagerPage", "*"),
  route(/^\/account-setting(?:\/|$)/, "AccountSetting", "*"),
  route(/^\/reports\/contact-list(?:\/|$)/, "Reports", "Contact List"),
  route(/^\/reports\/leep-report(?:\/|$)/, "Reports", "L.E.E.P. Report"),
  route(
    /^\/reports\/time-and-attendance(?:\/|$)/,
    "Reports",
    "Time and Attendance",
  ),
  route(/^\/reports\/expirations(?:\/|$)/, "Reports", "Expirations"),
  route(
    /^\/reports\/associate-turnover(?:\/|$)/,
    "Reports",
    "Associate Turnover",
  ),
  route(
    /^\/reports\/hiring-cycle-data(?:\/|$)/,
    "Reports",
    "Hiring Cycle Data",
  ),
  route(/^\/reports\/hiring-cycle(?:\/|$)/, "Reports", "Hiring Cycle"),
  route(/^\/reports\/position-history(?:\/|$)/, "Reports", "Position History"),
  route(/^\/reports\/termination(?:\/|$)/, "Reports", "Termination"),
  route(/^\/reports\/document-status(?:\/|$)/, "Reports", "Document Status"),
  route(
    /^\/reports\/incident-accident-registry(?:\/|$)/,
    "Reports",
    "Incident / Accident Registry",
  ),
  route(/^\/reports(?:\/|$)/, "Reports", "Reports Home"),
  route(/^\/status-history\//, "UserProfile", "Status History"),
  route(/^\/owner-operator-company\//, "UserProfile", "Personal Information"),
  route(/^\/application-history\//, "UserProfile", "Application History"),
  route(/^\/tags\//, "UserProfile", "Tags"),
  route(/^\/userhome(?:\/|$)/, "UserProfile", "Personal Information"),
  route(/^\/profile(?:\/|$)/, "UserProfile", "Personal Information"),
  route(/^\/training\//, "Training", "Online Training"),
  route(/^\/interview\//, "Interview", "Interview"),
  route(/^\/(?:edit-)?work-?history\//, "Task", "Work History"),
  route(/^\/(?:edit-)?healthcard\//, "Task", "Health Card"),
  route(/^\/(?:edit-)?fastcard\//, "Task", "Fast Card"),
  route(/^\/edit-task\/fast_card\//, "Task", "Fast Card"),
  route(/^\/(?:edit-)?fuelcard\//, "Task", "Fuel Card"),
  route(/^\/(?:edit-)?workpermit\//, "Task", "Work Permit"),
  route(/^\/driverabstract\//, "Task", "Driver Abstract"),
  route(/^\/roadtest\//, "Task", "Road Test"),
  route(/^\/roadside\//, "Task", "Roadside Inspection"),
  route(/^\/(?:edit-driver|driverlicense)\//, "Task", "Driver License"),
  route(/^\/(?:edit-)?vacation(?:form)?\//, "Task", "Vacation"),
  route(/^\/incidents\//, "Task", "Incident / Accident"),
  route(/^\/violations\//, "Task", "Violation"),
  route(
    /^\/annual-driver-certifications\//,
    "Task",
    "Annual Driver Certification",
  ),
  route(/^\/driver-disclosure\//, "Task", "Driver Disclosure"),
  route(/^\/dangerouswork\//, "Task", "Dangerous Work"),
  route(/^\/zerotolerance\//, "Task", "Zero Tolerance"),
  route(/^\/truckassignment\//, "Task", "Truck Assignment"),
  route(/^\/healthandsafety\//, "Task", "Health and Safety"),
  route(/^\/padlockpolicy\//, "Task", "Padlock Probe"),
  route(
    /^\/(?:slide\/)?background-check-fcra\//,
    "Task",
    "Background Check FCRA",
  ),
  route(/^\/qualifications\//, "Task", "Qualifications"),
  route(/^\/driver-agreement\//, "Task", "Driver Employee Agreement"),
  route(/^\/gatepasspolicy\//, "Task", "Gate Pass"),
  route(/^\/resume\//, "Task", "Resume"),
  route(/^\/leep\//, "Task", "L.E.E.P."),
  route(/^\/(?:slide\/)?consent(?:\/|$)/, "Task", "Consent"),
  route(/^\/signed-release\//, "Task", "Signed Release"),
  route(/^\/clearinghouse\//, "Task", "Clearinghouse"),
  route(/^\/reference-check-results\//, "Task", "Reference Check"),
  {
    pattern: /^\/(?:slide\/)?task\/([^/]+)/,
    page: "Task",
    resource: (match) => `Task:${decodeURIComponent(match[1])}`,
  },
];

const ADMIN_TAB_RESOURCES = {
  users: "User",
  drivers: "Driver License",
  healthcards: "Health Card",
  passports: "Passport",
  fastcards: "Fast Card",
  prcards: "PR Card",
  usvisa: "US Visa",
  workpermits: "Work Permit",
  workhistory: "Work History",
  vacation: "Vacation",
  emergency: "Emergency Contact",
  directdeposit: "Direct Deposit",
  fuelcards: "Fuel Card",
};

export function resolveRoutePermission(pathname, search = "") {
  if (pathname === "/admin") {
    const tab = new URLSearchParams(search).get("tab") || "users";
    return {
      page: "AdminDashboard",
      resource: ADMIN_TAB_RESOURCES[tab] || "User",
    };
  }
  for (const entry of PERMISSION_ROUTES) {
    const match = pathname.match(entry.pattern);
    if (match) {
      return {
        page: entry.page,
        resource:
          typeof entry.resource === "function"
            ? entry.resource(match)
            : entry.resource,
      };
    }
  }
  return null;
}
